import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const soehne = "'Soehne', sans-serif"

const tokens = {
  dark: {
    containerBg: 'bg.input', // duskBlue.800
    containerBorder: 'border.search', // duskBlue.600
    itemText: 'text.primary', // darkBlue.50
    itemHoverBg: 'bg.card-elevated', // darkBlue.700
  },
  light: {
    containerBg: 'light.bg.card', // white
    containerBorder: 'light.border.search', // ghostProtocol.200
    itemText: 'light.text.primary', // darkBlue.700
    itemHoverBg: 'light.bg.card-elevated', // ghostProtocol.50
  },
}

export const listSelectorContainerStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  bg: tokens[colorScheme].containerBg,
  border: '1px solid',
  borderColor: tokens[colorScheme].containerBorder,
  borderRadius: '0px',
  bottom: '100%',
  boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
  mb: '4px',
  overflow: 'hidden',
  position: 'absolute',
  right: 0,
  width: '214px',
  zIndex: 11,
})

export const listSelectorItemStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '100%',
  height: '40px',
  textAlign: 'left',
  px: '10px',
  fontFamily: soehne,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  cursor: 'pointer',
  color: tokens[colorScheme].itemText,
  bg: 'transparent',
  border: 'none',
  _hover: { bg: tokens[colorScheme].itemHoverBg },
  transition: 'background 0.15s ease',
})

export const listSelectorIconStyles: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '16px',
  height: '16px',
  p: '2px',
}

export const listSelectorDividerStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  borderTop: '1px solid',
  borderColor: tokens[colorScheme].containerBorder,
})
